module.exports = __webpack_public_path__ + "static/media/barbarian.1978fbbe.png";